import React, { useState } from "react";
import NavBar from "../../../Components/DesignSystem/NavBar";
import "../../../../css/Common/Pages/LandingPage/LandingPage.css";
import "../../../../css/App.css";
import { ReactComponent as Logo } from "../../../../assets/icons/logo-blue.svg";
import CardMain from "../../../Components/DesignSystem/Cards/CardMain";
import ButtonGreen from "frontend/Components/DesignSystem/Buttons/ButtonGreen";
import CardProduct from "../../../Components/DesignSystem/Cards/CardProduct";
import { ReactComponent as NewsIcon } from "../../../../assets/icons/news.svg";
import { ReactComponent as FinancialAdviceIcon } from "../../../../assets/icons/free-financial-advice.svg";
import { ReactComponent as BlogIcon } from "../../../../assets/icons/blog.svg";
import { ContactUs } from "frontend/Components/ContactForm/ContactUs";
import MapComponent from "frontend/Components/GoogleMaps/GoogleMaps";
import Footer from "../../../Components/DesignSystem/Footer";
import FinancialPerformanceDetails from "frontend/Components/FinancialPerformanceDocuments/FinancialPerformanceDetails";
import { useNavigate } from "react-router-dom";
import { RequestCallback } from "frontend/Components/ContactForm/RequestCallback";
import SeoHelmet from "frontend/Components/SEO/SeoHelmet";
import {
  SEO_PAGES,
  SEO_SITE,
  getPageUrl,
  getLogoUrl,
} from "frontend/Utils/seoConfig";
import ImageDirectory from "frontend/HelperFunctions/ImageDirectory";
import faqSchema from '../../../../faq-schema.json';



const LandingPage = () => {
  const navigationItems = [
    { label: "Advisers", navigateTo: "/Adviser" },
    { label: "Customers", navigateTo: "/Customer" },
    { label: "About Us", navigateTo: "/AboutUs" },
    { label: "Contact Us", navigateTo: "/ContactUs" },
  ];
  const navigate = useNavigate();
  const [isCallbackVisible, setCallbackVisible] = useState(false);

  /**
   * Handles the action to open the callback modal or component.
   * Sets the callback visibility state to true, triggering the display of the callback UI.
   * Can be used as an event handler for opening callback-related dialogs or popups.
   */
  const handleOpenCallback = () => {
    setCallbackVisible(true);
    // console.log("callback");
  };

  /**
   * Handles the close action for the callback component.
   * Sets the callback visibility state to false, effectively hiding the callback UI.
   *
   * @function
   * @returns {void}
   */
  const handleCloseCallback = () => {
    setCallbackVisible(false);
  };

  const landingPageStructuredData = {
    "@type": "FinancialService",
    "@id": `${SEO_SITE.siteUrl}/#financialservice`,
    name: SEO_SITE.siteName,
    url: SEO_SITE.siteUrl,
    logo: getLogoUrl(),
    image: getLogoUrl(),
    description: SEO_PAGES.landingPage.description,
    areaServed: "United Kingdom",
    address: {
      "@type": "PostalAddress",
      streetAddress: "Rosemount House, 2-4 Chequers Road",
      addressLocality: "Basingstoke",
      postalCode: "RG21 7PU",
      addressCountry: "GB",
    },
    telephone: "01256 405460",
    sameAs: [SEO_SITE.linkedinUrl],
    serviceType: [
      "Financial Advice",
      "Mortgage Advice",
      "Protection Advice",
      "Financial Planning",
      "Adviser Network Support",
      "Mortgage Adviser Support",
      "Financial Adviser Support",
    ],
  };

  const siteNavigationStructuredData = {
    "@type": "ItemList",
    name: "Rosemount Financial Solutions Main Navigation",
    itemListElement: [
      {
        "@type": "SiteNavigationElement",
        position: 1,
        name: "Advisers",
        url: getPageUrl("/Adviser"),
      },
      {
        "@type": "SiteNavigationElement",
        position: 2,
        name: "Customers",
        url: getPageUrl("/Customer"),
      },
      {
        "@type": "SiteNavigationElement",
        position: 3,
        name: "About Us",
        url: getPageUrl("/AboutUs"),
      },
      {
        "@type": "SiteNavigationElement",
        position: 4,
        name: "Contact Us",
        url: getPageUrl("/ContactUs"),
      },
    ],
  };

  return (
    <>
      <SeoHelmet
        page={SEO_PAGES.landingPage}
        breadcrumbs={[
          {
            name: "Home",
            url: getPageUrl("/"),
          },
        ]}
        extraSchemas={[landingPageStructuredData, siteNavigationStructuredData]}
      />
      <NavBar navigationItems={navigationItems} />
      <div className="Landing-Page">
        <div className="Hero-Landing-Page">
          <div className="Landing-Page-Logo-Container">
            <Logo />
            <h1>Rosemount Financial Solutions (IFA) Ltd</h1>
          </div>
          <div className="Role-Picker-Container">
            <div className="SubTitle">
              Are you a Customer or a Financial Adviser?
            </div>
            <div className="Roles">
              <CardMain
                title="I'm an Adviser"
                imgSrc={ImageDirectory["advisers-home"]}
                imgSrcSmall={ImageDirectory["advisers-home"]}
                navigateTo="/Adviser"
                altText="Two advisers sat by a laptop, one typing with the other instructing."
              />
              <CardMain
                title="I’m a Customer"
                imgSrc={ImageDirectory["customer-home"]}
                imgSrcSmall={ImageDirectory["customer-home"]}
                navigateTo="/Customer"
                altText="A couple sat together on the sofa looking at a laptop and smiling."
              />
            </div>
          </div>
        </div>
        <FinancialPerformanceDetails title="Key Attributes" />

        <div className="About-Us">
          <div className="About-Us-Container">
            <img
              loading="eager"
              fetchPriority="high"
              src={ImageDirectory["about-us-small"]}
              alt="Two advisers in business attire smiling."
            />
            <div className="About-Us-Content">
              <h2>About Us</h2>
              <ButtonGreen
                buttonText="Read More"
                onClick={() => {
                  // window.location.href = "/AboutUs";
                  navigate("/AboutUs");
                }}
              />

              <div className="SubTitle">
                We are a full financial planning firm with nationwide coverage.
                Our advisers grow meaningful relationships to build bespoke
                plans for your goals.
              </div>
            </div>
          </div>
          <div className="Adviser-Services-Holder1">
            <CardProduct
              Icon={NewsIcon}
              title="News"
              link="/RosemountInMedia"
            />
            <div onClick={handleOpenCallback}>
              <CardProduct
                Icon={FinancialAdviceIcon}
                title="Free Initial Consultation"
              />
            </div>
            <CardProduct Icon={BlogIcon} title="Blog" link="/RosemountBlog" />
            {/* <CardProduct Icon={ServicesIcon} title="Our Resources" link="/" /> */}
          </div>
        </div>

        <ContactUs />
        <MapComponent />

        {/* <TimeSelector /> */}
        <Footer />
        {isCallbackVisible && (
          <div className="notification-overlay">
            <RequestCallback
              title="Free Initial Consultation"
              onClose={() => handleCloseCallback()}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default LandingPage;

